import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors, rt) => ({
  container: {
    flex: 1,
    paddingHorizontal: theme.spacing[5],
    paddingTop: theme.spacing[5],
  },
  servicesGrid: {
    flexDirection: 'column',
    gap: theme.spacing[4],
    paddingBottom: rt.insets.bottom + theme.spacing[4],
  },
  card: {
    paddingHorizontal: theme.spacing[5],
    paddingVertical: theme.spacing[5],
    borderRadius: theme.borderRadius.m,
    borderWidth: 1.5,
    borderColor: colors.backgroundL1,
  },
  priceRow: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  priceSkeleton: {
    height: 24,
    width: 72,
    borderRadius: theme.borderRadius.xs,
    backgroundColor: colors.backgroundL1,
  },
  buttonSkeleton: {
    height: theme.spacing[7],
    width: 120,
    borderRadius: theme.borderRadius.full,
    backgroundColor: colors.backgroundL1,
  },
}));
